import {
  DropdownForm,
  FormUpdateDialog,
} from "@/components/data_table/FormUpdate";
import { useListDepartment } from "../utils";
import { useState } from "react";
import { phanBo } from "../api";
const DivideDialog = (props) => {
  const { visible, setVisible, selectedProducts, setParams } = props;
  const [infos, setInfos] = useState({
    leads: selectedProducts?.map((e) => e.id),
    department_id: "",
  });
  const list_department = useListDepartment({
    status: undefined,
  });
  const handleData = () => {
    return infos;
  };
  return (
    <FormUpdateDialog
      title="PHÂN BỔ PHÒNG BAN"
      visible={visible}
      setVisible={setVisible}
      refreshObjects={[setInfos]}
      handleData={handleData}
      actions={{ update: phanBo }}
      checkId={Number(visible)}
      setParams={setParams}
    >
      <div>
        <DropdownForm
          value={infos?.department_id}
          onChange={(e) =>
            setInfos({ ...infos, department_id: e.target.value })
          }
          options={list_department}
          optionLabel={(option) =>
            `${option.gb_title}  (${option.gb_id} - ${option.reference_code}) `
          }
          optionValue="gb_id"
          label="Phòng ban"
        />
      </div>
      <div style={{ height: "25vh" }}></div>
    </FormUpdateDialog>
  );
};
export default DivideDialog;
